// Query parameter keys for URL state management
export const QUERY_PARAM_KEYS = {
  SORT: 'sort',
  STATUS: 'status',
  TYPE: 'type',
  APPS: 'apps',
  DURATION: 'duration',
  NOTIFICATION_TYPE: 'notificationType',
} as const;

// Default sort value
export const DEFAULT_SORT = 'More recent';

// Content type values (internal representation)
export const CONTENT_TYPE_VALUES = {
  LESSON: 'lesson',
  COURSE: 'course',
  LEARNING_PATH: 'learningPath',
} as const;

// Status labels for display and filtering
export const STATUS_LABELS = {
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  COMPLETE: 'Complete',
  SAVED: 'Saved',
  RETIRED: 'Retired',
} as const;

// Content type labels for display
export const CONTENT_TYPE_LABELS = {
  LESSON: 'Lesson',
  COURSE: 'Course',
  LEARNING_PATH: 'Learning Path',
} as const;

// Default product name
export const DEFAULT_PRODUCT = 'Atlassian';

// Application routes
export const ROUTES = {
  CATALOG: '/catalog',
  LEARNING_PREFIX: '/learning',
  PATH_PREFIX: '/path/',
} as const;

// Filter section titles
export const FILTER_SECTION_TITLES = {
  STATUS: 'Status',
  TYPE: 'Type',
  APP: 'App',
  DURATION: 'Duration',
  SORT_BY: 'Sort by',
  FILTER_BY: 'Filter by',
} as const;
